"use strict";

var _classCallCheck = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionsColor = void 0;

var OptionsColor = /*#__PURE__*/function () {
  function OptionsColor() {
    _classCallCheck(this, OptionsColor);

    this.value = "#fff";
  }

  _createClass(OptionsColor, [{
    key: "load",
    value: function load(data) {
      if ((data === null || data === void 0 ? void 0 : data.value) === undefined) {
        return;
      }

      this.value = data.value;
    }
  }], [{
    key: "create",
    value: function create(source, data) {
      var color = source !== null && source !== void 0 ? source : new OptionsColor();

      if (data !== undefined) {
        color.load(typeof data === "string" ? {
          value: data
        } : data);
      }

      return color;
    }
  }]);

  return OptionsColor;
}();

exports.OptionsColor = OptionsColor;